import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Typography} from '@material-ui/core';
import AfficheImage from 'components/Shared/AfficheImage';

import DEFAULT_LOGO from './logoCinemaCard.jpg';

import './CinemaCard.scss';

const useStyles = makeStyles(theme => ({
  text: {
    color: 'white',
    transition: 'all 0.2s ease',
    [theme.breakpoints.only('xs')]: {
      fontSize: '4.6vw',
    },
    [theme.breakpoints.only('sm')]: {
      fontSize: '1.7vw',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '1.42vw',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: 20,
    },
  },
  infoTitle: {
    color: 'white',
    transition: 'all 0.2s ease',
    [theme.breakpoints.only('xs')]: {
      fontSize: '8vw',
    },
    [theme.breakpoints.only('sm')]: {
      fontSize: '3vw',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '2.5vw',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: 35,
    },
  },
}));

const CinemaCard = ({cinema, goTo, ratio = 1}) => {
  const classes = useStyles();

  if (!cinema) return null;

  return (
    <div
      className="cinema-slider-cartouche"
      style={{cursor: 'pointer'}}
      onClick={() => goTo('/cinema/' + cinema.cinema_id)}
    >
      <AfficheImage
        affiche={cinema.logo || DEFAULT_LOGO}
        ratio={ratio}
        alt={`${cinema.cinema_name} logo`}
      />
      <div className="cinema-slider-cartouche-overlay" />
      <div className={`${classes.text} cinema-slider-cartouche-text`}>
        <Typography noWrap variant="h5" className={classes.text}>
          {cinema.city_name}
        </Typography>
        <Typography variant="h3" component="h3" className={classes.infoTitle}>
          {cinema.cinema_name}
        </Typography>
      </div>
    </div>
  );
};

export default CinemaCard;
